import store from "../../redux/store"
import { Log, LogSeverity } from "../../types/usage/log"
import { sendLogs } from "./logs-queue"

export const logger = async (event: string, log: Partial<Log>, severity: LogSeverity = LogSeverity.Info): Promise<void> => {
  sendLogs(enrichContextLogs({ event, ...log }, severity))
}

/**
 * Enriches the log with the current user and charity context
 * @param data Logs to send
 * @param severity Severity of the log
 * @returns Enriched log
 */
function enrichContextLogs(data: Partial<Log>, severity: LogSeverity): Log {
  const log: Log = {
    flow: 'tap_to_donate_dashboard',
    severity,
    ...data,
    eventDate: new Date().valueOf(),
  }
  const username = store.getState().auth.username
  const charityId = store.getState().auth.charity?._id
  if (username !== undefined) {
    log.username = username
  }
  if (charityId !== undefined) {
    log.charityId = charityId
  }
  return log
}